import { useQuery } from 'react-query';
import { GET_SAVED_WITHDRAWAL_MODES } from '../appConstants/APIEndpoint';
import { requestApiGet } from './index';
import type { ISavedWithdrawalModes } from '../interfaces/Withdrawal';

/**
 * The saved withdrawal modes screen.
 * Mirrors `SavedWithdrawalModesViewModel.getSavedWithdrawalModesData`.
 *
 * Returns a `bank` and a `vpa` block, each either an "add" prompt
 * (`addWithdrawalModeData`) or the linked mode's details (`withdrawalModes`).
 */
export const fetchSavedWithdrawalModes = async (): Promise<ISavedWithdrawalModes> => {
  const res = await requestApiGet<ISavedWithdrawalModes>(
    GET_SAVED_WITHDRAWAL_MODES,
  );
  const response = res?.response;

  if (!response?.success) {
    throw new Error(response?.error || 'Could not load your withdrawal modes');
  }
  return response?.data ?? {};
};

export const useSavedWithdrawalModes = (enabled: boolean = true) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['savedWithdrawalModes'],
    queryFn: fetchSavedWithdrawalModes,
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return { savedModes: data, isLoading, error, refetch };
};

export default useSavedWithdrawalModes;
